import { Outlet } from "react-router-dom";
import { Helmet as Head, HelmetProvider } from 'react-helmet-async';
import { Row, Col, Container } from 'react-bootstrap';
import SideNav from '../sideNav';
import PortalLogo from '../../assets/portalLogo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { isCollapsed } from '../recoil';
import {useAtom} from 'jotai';
import cx from 'classnames';
import { PortalContextProvider } from '../../lib/context/portalContext';
import PageHeader from '../pageHeader';
import UserAgreement from '../user-agreement';
import RefreshToken from '../auth/manualRefreshToken';
import SystemMessages from '../system-message';
import CustomerContextProvider from '../../lib/context/customerContext';
import FeatureContextProvider from '../../lib/context/featureContext';

export const Main = () => {
  const [collapsed, setCollapsed] = useAtom(isCollapsed);

  const handleClick = () => {
    setCollapsed(!collapsed);
  };

  return <>
    <HelmetProvider>
      <Head>
        <title>Privoro</title>
        <meta charSet='utf-8' />
        <meta name='viewport' content='initial-scale=1.0, width=device-width' />
        <meta httpEquiv="Cache-control" content="no-cache" />
      </Head>
    </HelmetProvider>
    <UserAgreement>
      <FeatureContextProvider>
        <CustomerContextProvider>
          <PortalContextProvider>
            <SystemMessages />
            <Container fluid data-testid="main-layout">
              <Row className="flex-nowrap">
                <Col xs="auto" id="side-nav-container" className={cx(collapsed && 'collapsed')}>
                  <div className="sticky-top z-0">
                    <div className="logo-container">
                      <PortalLogo />  
                    </div>                    
                    <SideNav />
                    <span
                      data-target="side-nav-container"
                      onClick={handleClick}
                      className={cx('fa-layers fa-fw fa-lg pointer toggle-stack', collapsed && 'collapsed')}
                    >
                      <FontAwesomeIcon icon={faCircle} />
                      <FontAwesomeIcon transform="shrink-6" id="nav-toggle" icon={faChevronLeft} color="black" />
                    </span>
                  </div>
                </Col>
                <Col className="main-container">
                  <div className="d-block position-relative">
                    <PageHeader />
                    <Outlet />
                  </div>
                </Col>
              </Row>
            </Container>
          </PortalContextProvider>
        </CustomerContextProvider>
      </FeatureContextProvider>
    </UserAgreement>
    <RefreshToken />
  </>;
};

export const Empty = () => {
  return <Outlet />;
};

export default Main;
